// Helper for Constant Contact email sign-up form
// https://github.com/Threespot/pan-foundation/issues/150

class FormParameters {
  constructor(el) {
    this.el = el;
    this.footerFormSubmit = this.el.querySelector(".FooterSignup-submit");
    this.emailAddress = this.el.querySelector("#signup-email");
    this.parameters = localStorage.getItem("newsLetterEmail");
    this.emailInputs = this.el.querySelectorAll('input[type="email"]');

    this.clickedSubmit(this.footerFormSubmit, this.emailAddress);

    if (this.parameters) {
      this.populateInput(this.emailInputs, this.parameters);
    }
  }

  clickedSubmit(clickedEl, data) {
    if (clickedEl) {
      clickedEl.addEventListener("click", () => {
        localStorage.setItem("newsLetterEmail", data.value);
      });
    }
  }

  populateInput(inputs = [], value) {
    inputs.forEach((input) => {
      input.setAttribute("value", value);
    });
  }
}

const init = () => {
  document.querySelectorAll("form").forEach((el) => {
    new FormParameters(el);
  });
};

// Init on initial page load
init();

